import { FC } from 'react';
import { PhoenixIcon } from '@phoenix/design-system/frontend/ui/phoenix-icon/phoenix-icon';
import { getDesignSystemIcon } from '@phoenix/design-system/frontend/util/path.utils';

const uploadIcon = getDesignSystemIcon('icon-stihl-upload.svg');

export const UploadImagePlaceholder: FC<React.PropsWithChildren> = () => (
  <div
    className="flex h-[4.375rem] w-[4.375rem] cursor-pointer items-center justify-center border border-dashed border-secondary-deep text-secondary-deep"
    data-testid="upload-image-placeholder"
  >
    <PhoenixIcon className="h-4 w-4" icon={uploadIcon} />
  </div>
);
